// import React, { useState, useEffect } from 'react';
// import { Link } from 'lucide-react';
// import {
//   fetchAvailableBuilds,
//   generateSingleLink,
// } from './api';

// import SingleLinkForm from './SingleLinkForm';
// import GeneratedLinkCard from './GeneratedLinkCard';

// const PresignLinkGenerator = () => {
//   const [loading, setLoading] = useState(false);
//   const [availableBuilds, setAvailableBuilds] = useState({});
//   const [generatedLink, setGeneratedLink] = useState(null);
//   const [copied, setCopied] = useState(null);
//   const [message, setMessage] = useState(null); 
  

//   const [formData, setFormData] = useState({
//     build_id: '',
//     expiration_hours: 24,
//     user_email: '',
//     purpose: '',
//   });

//   useEffect(() => {
//     const loadBuilds = async () => {
//       const data = await fetchAvailableBuilds();
//       if (data.success) {
//         setAvailableBuilds(data.builds);
//         const firstBuildId = Object.keys(data.builds)[0];
//         setFormData((p) => ({ ...p, build_id: firstBuildId }));
//       }
//     };
//     loadBuilds();
//   }, []);

//   const handleSingleLink = async () => {
//   setLoading(true);
//   setMessage(null); // clear previous message

//   const data = await generateSingleLink(formData);

//   if (data.success) {
//     setGeneratedLink(data);
//     setMessage({
//       type: "success",
//       text: "Link generated successfully!",
//     });
//   } else {
//     setMessage({
//       type: "error",
//       text: data.error || "Failed to generate link.",
//     });
//   }

//   setLoading(false);
// };


//   const copyToClipboard = async (text, index = null) => {
//     try {
//       await navigator.clipboard.writeText(text);
//       setCopied(index !== null ? `bulk-${index}` : 'single');
//       setTimeout(() => setCopied(null), 2000);
//     } catch {
//       // fallback
//     }
//   };

//   return (
//     <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-lg">
//       <h1 className="text-3xl font-bold text-gray-800 mb-8 flex items-center gap-3">
//         <Link className="text-blue-600" />
//         Presign Link Generator
//       </h1>

//       <SingleLinkForm
//         formData={formData}
//         setFormData={setFormData}
//         availableBuilds={availableBuilds}
//         loading={loading}
//         onGenerate={handleSingleLink}
//       />

//       {generatedLink && (
//         <GeneratedLinkCard
//           generatedLink={generatedLink}
//           copied={copied}
//           copyToClipboard={copyToClipboard}
//         />
//       )}

//     </div>
//   );
// };

// export default PresignLinkGenerator;


import React, { useState, useEffect, useContext } from "react";
import { Link } from "lucide-react";
import { fetchTherapistBuilds, generateSingleLink } from "./api"; // ✅ updated import
import SingleLinkForm from "./SingleLinkForm";
import GeneratedLinkCard from "./GeneratedLinkCard";
import Navbar from "../../../components/Navbar";
import TherapistSidebar from "../../../components/TherapistSidebar";
import { AuthContext } from "../../../context/AuthContext";
import axios from 'axios';
import Env from '../../../runtimeEnv';
import { isDemoMode } from '../../../demo/demoMode';

const TherapistPresignLinkGenerator = () => {
  const [loading, setLoading] = useState(false);
  const [availableBuilds, setAvailableBuilds] = useState({});
  const [generatedLink, setGeneratedLink] = useState(null);
  const [copied, setCopied] = useState(null);
  const [message, setMessage] = useState(null);
  const [activeNavItem, setActiveNavItem] = useState("generate-link");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { userType, therapistEmail } = useContext(AuthContext);


  const [formData, setFormData] = useState({
    build_id: "",
    expiration_hours: 24,
    user_email: "",
    purpose: "",
  });

  // useEffect(() => {
  //   const loadTherapistBuilds = async () => {
  //     const data = await fetchTherapistBuilds(); // ✅ fetch therapists + builds
  //     if (data.success) {
  //       // Convert API array → object for dropdown
  //       const therapistMap = {};
  //       data.therapists.forEach((t) => {
  //         therapistMap[t.therapist_id] = {
  //           name: t.name,
  //           description: t.description,
  //           url: t.url,
  //         };
  //       });

  //       setAvailableBuilds(therapistMap);

  //       // Set first therapist as default
  //       const firstTherapistId = Object.keys(therapistMap)[0];
  //       setFormData((prev) => ({ ...prev, build_id: firstTherapistId }));
  //     }
  //   };

  //   loadTherapistBuilds();
  // }, []);

  useEffect(() => {
  const loadTherapistBuilds = async () => {
    const data = await fetchTherapistBuilds();

    if (!data.success) {
      setMessage({ type: "error", text: "Unable to load therapists. Please reload to try again." });
      return;
    }

    const therapistMap = {};
    data.therapists.forEach((t) => {
      therapistMap[t.therapist_id] = {
        name: t.name,
        description: t.description,
        url: t.url,
      };
    });

    setAvailableBuilds(therapistMap);

    // -------------------------
    // AUTO-SELECT LOGGED-IN THERAPIST
    // -------------------------

    const email = therapistEmail?.trim().toLowerCase();
    const match = data.therapists.find((therapist) =>
      [therapist.email, ...(therapist.email_aliases || [])]
        .some((address) => address?.toLowerCase() === email)
    );
    let matchedId = match?.therapist_id;
if (!matchedId && isDemoMode) {
  matchedId = Object.keys(therapistMap)[0] || "";
}
if (!matchedId) {
  matchedId = ""; // leave dropdown blank
}




    
    setFormData((prev) => ({
      ...prev,
      build_id: matchedId,
    }));
  };

  loadTherapistBuilds();
}, [therapistEmail]);


  const handleSingleLink = async () => {
    setLoading(true);
    setMessage(null);

    try {
      const data = await generateSingleLink(formData);

      if (data.success) {
        setGeneratedLink(data);
        const didCopy = await copyToClipboard(data.url);
        setMessage({
          type: "success",
          text: didCopy
            ? "Link generated and copied to your clipboard."
            : "Link generated successfully. Tap Copy to copy it.",
        });
      } else {
        setMessage({
          type: "error",
          text: data.error || "Failed to generate link.",
        });
      }
    } catch (error) {
      setMessage({
        type: "error",
        text: "The session link service is currently unavailable. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = async (text, index = null) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(index !== null ? `bulk-${index}` : "single");
      setTimeout(() => setCopied(null), 2000);
      return true;
    } catch {
      try {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        const copiedSuccessfully = document.execCommand("copy");
        document.body.removeChild(textArea);
        if (copiedSuccessfully) {
          setCopied(index !== null ? `bulk-${index}` : "single");
          setTimeout(() => setCopied(null), 2000);
        }
        return copiedSuccessfully;
      } catch {
        return false;
      }
    }
  };

  return (
    
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <TherapistSidebar
        activeNavItem={activeNavItem}
        setActiveNavItem={setActiveNavItem}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      <main className="min-h-screen px-4 pb-28 pt-24 lg:pl-72 lg:pr-8 lg:pb-10">
        <div className="mx-auto w-full max-w-4xl rounded-2xl bg-white p-5 shadow-lg sm:p-7">
          <h1 className="mb-6 text-2xl font-bold leading-tight text-gray-800 sm:text-3xl">
            <span className="sm:hidden">Guest Session Link Generator</span>
            <span className="hidden sm:inline">Instant Session Link Generator</span>
          </h1>

          <SingleLinkForm
            formData={formData}
            setFormData={setFormData}
            availableBuilds={availableBuilds}
            loading={loading}
            onGenerate={handleSingleLink}
          />

          {message && (
            <div
              className={`mt-4 rounded-lg px-4 py-3 text-sm font-medium ${
                message.type === "success"
                  ? "bg-green-50 text-green-800"
                  : "bg-red-50 text-red-800"
              }`}
            >
              {message.text}
            </div>
          )}

          {generatedLink && (
            <GeneratedLinkCard
              generatedLink={generatedLink}
              copied={copied}
              copyToClipboard={copyToClipboard}
            />
          )}
        </div>
      </main>
    </div>
  );
};

export default TherapistPresignLinkGenerator;
